import React, { useState } from "react";
import "./stylesheets/contact.css";
import contact from "../assets/Contact.png";
import { Button, Input, Textarea } from "@chakra-ui/react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";
import { useToast } from "@chakra-ui/react";

const Contact = () => {
  const toast = useToast();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const handleContactMessageFormSubmit = (event) => {
    event.preventDefault();
    fetch("https://jksingh-portfolio-server.vercel.app/api/contactMail", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) =>
        toast({
          title: "Contact mail sent.",
          description: data,
          status: "success",
          duration: 5000,
          isClosable: true,
        })
      );
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <>
      <div id="contact">
        <h1>
          Take A <span style={{ color: "#dc143c" }}>Coffee</span> And{" "}
          <span style={{ color: "#dc143c" }}>Chat</span> With Me
        </h1>
        <div className="contact_child">
          <div>
            <img
              style={{ maxWidth: "90%", margin: "auto" }}
              src={contact}
              alt="contact"
            />
          </div>
          <div className="emailSender">
            <div
              className="social_buttons"
              style={{
                width: "100%",
                overflowX: "scroll",
                paddingBottom: "8px",
                boxSizing: "border-box",
                display: "flex",
                flexWrap: "nowrap",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              <a
                href="https://www.linkedin.com/in/jyoti-kamal-singh/"
                target="_blank"
              >
                <Button className="contactButton" colorScheme="linkedin">
                  <LinkedInIcon boxsize={4} style={{ marginRight: "10px" }} />
                  Linkedin
                </Button>
              </a>
              <a href="https://github.com/jksingh1504" target="_blank">
                <Button
                  className="contactButton"
                  colorScheme="navyblue"
                  style={{ background: "#373b41", backgroundColor: "#373b41" }}
                >
                  <GitHubIcon boxsize={4} style={{ marginRight: "10px" }} />{" "}
                  Github
                </Button>
              </a>
              <a href="mailto:jyotikamal.official@gmail.com" target="_blank">
                <Button className="contactButton" colorScheme="red">
                  <EmailIcon boxsize={4} style={{ marginRight: "10px" }} />
                  Gmail
                </Button>
              </a>
            </div>
            <div>
              <form onSubmit={handleContactMessageFormSubmit}>
                <Input
                  required
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Full Name"
                />
                <Input
                  required
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                />
                <Textarea
                  rows={5}
                  required
                  resize="none"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Here is a sample placeholder"
                />
                <Button
                  type="submit"
                  style={{ width: "80%", margin: "auto" }}
                  colorScheme="red"
                >
                  Send Message
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="contact_footer">
        <p style={{ width: "100%", textAlign: "center", color: "white" }}>
          Designed and build by Jyoti Kamal Singh, 2022 All rights reserved.
        </p>
        {/* <div>
          <a href="#home">
            <h1>Home</h1>
          </a>
        </div> */}
      </div>
    </>
  );
};

export default Contact;
